export const TEMPLATE_STRINGS = [
  { template: '{{user_first_name}}', description: 'messageVariables.name' },
  { template: '{{user_last_name}}', description: 'messageVariables.lastName' },
  { template: '{{booking_date}}', description: 'messageVariables.recordingDate' },
  { template: '{{booking_time}}', description: 'messageVariables.recordingTime' },
  { template: '{{business_name}}', description: 'messageVariables.organizationName' },
]
